import React from "react";
import { formatPercentage } from "@signolteam/shared/units-of-measure";
import { useDCContext } from "@src/context";
import { useManagerContext } from "@src/context/managerContext";
import { formatNumber } from "@src/constants/convertions";
import PieChartLib from "../../graphs/PieChart";
import CardContainer from "../CardContainer";
import { Loader } from "../../atoms";

/** Half-circle/semicircle pie chart of better vs worse */
const BehaviourSuccessOrSavingsChangeSpeedometer = ({
  /** true=Success Rate, false=Fuel Savings */
  isSuccessRate,
  isLoading,
  valueImproved,
  valueTotal,
}) => {
  const { selectedBehaviour, selectedBehaviourColour } = useManagerContext();
  const { getDynamicReplacement } = useDCContext();
  const valueNotImproved = valueTotal - valueImproved;
  const ratioImproved = valueImproved / valueTotal;

  const dcPrefix = isSuccessRate
    ? "fuel_manager__behaviour__success_section__success_change_chart"
    : "fuel_manager__behaviour__fuel_saving_section__fuel_saving_change_chart";
  const changeChartTitle = getDynamicReplacement(`${dcPrefix}_title`);
  const changeChartKey = getDynamicReplacement(`${dcPrefix}_key`);
  const changeChartOperatorNumber = getDynamicReplacement(
    `${dcPrefix}_operator_number`,
    {
      NUMBER: formatNumber(valueImproved),
    },
  );
  return (
    <CardContainer addaptivePadding>
      <div style={{ minHeight: "210px" }}>
        <div className="text-neutral-500 text-base font-bold mb-3">
          {changeChartTitle}
        </div>
        {isLoading ? (
          <div
            className="h-full w-full flex flex-col justify-center"
            style={{ minHeight: "210px" }}
          >
            <Loader size="2xl" />
          </div>
        ) : (
          <div className="w-full flex flex-col">
            <div className="flex items-center text-sm mb-6">
              <span
                className={`inline-block w-3 h-3 bg-${selectedBehaviourColour.name}-300 rounded-xl mr-2`}
              />
              {changeChartKey}
            </div>
            <div className="self-center relative">
              <PieChartLib
                data={[
                  {
                    name: "Improved",
                    value: valueImproved,
                    colour: selectedBehaviourColour.codes[300],
                  },
                  {
                    name: "Equal or worse",
                    value: valueNotImproved,
                    colour: "#F0F0F0",
                  },
                ]}
                arc={true}
                hideTooltips={true}
              />
              <div
                className="absolute z-20 text-sm font-medium"
                style={{ left: "4%", bottom: 0 }}
              >
                0%
              </div>
              <div
                className="absolute z-20 text-sm font-medium"
                style={{ right: 0, bottom: 0 }}
              >
                100%
              </div>
              <div
                className="absolute z-20 w-full flex flex-col items-center"
                style={{ top: "40%" }}
              >
                <div className="text-black text-4xl">
                  {formatPercentage("0-1", ratioImproved).asString}
                </div>
                <div
                  className={`text-${selectedBehaviourColour.name}-400 text-sm`}
                >
                  {changeChartOperatorNumber}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </CardContainer>
  );
};

export default BehaviourSuccessOrSavingsChangeSpeedometer;
